"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var SisDocComponent = /** @class */ (function () {
    function SisDocComponent() {
        this.onDownload = new core_1.EventEmitter();
    }
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisDocComponent.prototype, "onDownload", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDocComponent.prototype, "getImageClass", void 0);
    SisDocComponent = __decorate([
        core_1.Component({
            selector: 'sis-doc',
            template: "\n               <div (click)=\"onDownload.emit($event)\">\n                 <i class=\"{{getImageClass}}\" aria-hidden=\"true\" style=\"font-size: 24px\"></i>\n               </div>\n             ",
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n        <sis-doc (onDownload)=\"%{onDownload}\" [getImageClass]=\"%{getImageClass}\"></sis-doc>\n    ",
        })
        /**
         * @deprecated - use sis-document from ng-controls
         */
    ], SisDocComponent);
    return SisDocComponent;
}());
exports.SisDocComponent = SisDocComponent;
//# sourceMappingURL=sis-doc.component.js.map